import React from 'react';
import styled from '@emotion/styled';
import { Table, TablePaginationConfig } from 'antd';
import { useTranslation } from 'react-i18next';
import { GRAPHICS } from '../../../constants/define/translation';
import { appStyles } from '../../../styles';
import { CommonColumn, IndexColumn } from '../shared-column';
import TextActionColumn from './column/TextActionColumn';

interface TextsTableProps {
  records?: any[];
  loading?: boolean;
  className?: string;
  pagination?: TablePaginationConfig;
  onRefresh?: (loading?: boolean) => void;
  onLoading: (loading: boolean) => void;
  onHandleClickBtnEdit: (record: any) => void;
}

const { Column } = Table;
export const TextsTable = (props: TextsTableProps) => {
  const { t } = useTranslation(GRAPHICS);
  const { records, pagination, onRefresh, onLoading, onHandleClickBtnEdit } = props;

  return (
    <>
      <StyledTable
        dataSource={records}
        loading={props.loading}
        className={props.className}
        rowKey="index"
        pagination={pagination}
      >
        <Column
          title={t('table.title.index')}
          align="center"
          width={32}
          dataIndex="index"
          key="index"
          render={(value, record: any) => <IndexColumn value={value} />}
        />
        <Column
          title={t('table.title.key')}
          align="center"
          dataIndex="keyText"
          key="keyText"
          render={(value, record: any) => <CommonColumn value={record?.keyText} />}
        />
        <Column
          title={t('table.title.value')}
          align="center"
          dataIndex="value"
          key="value"
          render={(value, record: any) => <CommonColumn value={record?.value} />}
        />
        <Column
          title={t('table.title.action')}
          align="center"
          width={60}
          render={(value, record: any) => (
            <TextActionColumn
              record={record}
              onHandleClickBtnEdit={onHandleClickBtnEdit}
              onRefresh={onRefresh}
              onLoading={onLoading}
            />
          )}
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .ant-table-thead {
    border-bottom: 2px solid #eee;
    & > th > tr {
      ${appStyles.background.tableBgGray}
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: 600;
      border: 1px solid #dededee3;
      &:before {
        display: none;
      }
    }
  }

  .ant-pagination-item a {
    line-height: 30px;
  }
`;
